import {SLUGS} from '@px/const/slugs';
import {appendTemplates} from '@px/helper/template';

export const templates: Template[] = [
  {
    slug: SLUGS.EARN_HOME,
    loader: () => import('px-home/src/modules/earn-home'),
  },
  {
    slug: SLUGS.EARN_SAVINGS_ACCOUNT,
    loader: () => import('px-home/src/modules/earn'),
  },
  {
    slug: SLUGS.EARN_MY_EARNINGS,
    loader: () => import('px-home/src/modules/earn/my-earnings'),
  },
  {
    slug: SLUGS.EARN_LIMITED_TIME_OFFER,
    loader: () => import('px-home/src/modules/limited-time-offer'),
  },
  {
    slug: SLUGS.EARN_LAUNCHPOOL,
    loader: () => import('px-home/src/modules/launchpool'),
  },
  {
    slug: SLUGS.EARN_PREDICT_TO_EARN,
    loader: () => import('px-home/src/modules/predict-to-earn'),
  },
  {
    slug: SLUGS.EARN_PREDICT_TO_EARN_DETAIL,
    loader: () => import('px-home/src/modules/predict-to-earn-detail'),
  },
  {
    slug: SLUGS.EARN_PREDICT_TO_EARN_HISTORY,
    loader: () => import('px-home/src/modules/predict-to-earn-histroy'),
  },
  {
    slug: SLUGS.EARN_CRYPTO_CONVERTER,
    loader: () => import('px-home/src/modules/crypto-converter'),
  },
  {
    slug: SLUGS.EARN_LAUNCHPAD,
    loader: () => import('px-home/src/modules/launchpad/list'),
  },
  {
    slug: SLUGS.EARN_LAUNCHPAD_DETAIL,
    loader: () => import('px-home/src/modules/launchpad/detail'),
  },
  {
    slug: SLUGS.EARN_LAUNCHPAD_HISTORY,
    loader: () => import('px-home/src/modules/launchpad/history'),
  },
];

appendTemplates(templates);
